/**
 * SocketStatusBadge Component
 *
 * Displays the connection status of a socket (connected/disconnected).
 * Shows color-coded badge with icon.
 *
 * Issue: #1 - Auto-Unassignment
 */

import React from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import { CheckCircle, Cancel } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  connected: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  disconnected: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

const SocketStatusBadge = ({ connected, size = 'small' }) => {
  const classes = useStyles();

  if (connected) {
    return (
      <Chip
        icon={<CheckCircle style={{ color: 'white' }} />}
        label="Connected"
        size={size}
        className={classes.connected}
      />
    );
  }

  return (
    <Chip
      icon={<Cancel style={{ color: 'white' }} />}
      label="Disconnected"
      size={size}
      className={classes.disconnected}
    />
  );
};

export default SocketStatusBadge;
